import { Card, Col, Image, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { setCategory } from '../../redux/slices/filtersSlice';
import { store } from '../../redux/store';
import { getRoutes } from '../../routes/Routes';
import HeroCarousel from './../../components/ui/HeroCarousel/index';
import { categories, PLACEHOLDER_IMAGE } from './../../constants';

const { Title, Text } = Typography;

const Home = () => {

    const slides = [
        {
            title: 'Fresh Halal Poultry',
            description:
                'Halal fresh poultry is a cornerstone of many restaurant and catering menus, offering versatility across a wide range of cuisines.',
            image: 'https://www.magnafoodservice.co.uk/wp-content/uploads/myths-about-frozen-chicken.jpg',
            button: {
                text: 'View Catalogue',
                link: getRoutes().public_catalogue.route(),
            }
        },
        {
            title: 'Fresh Produce Delivered',
            description:
                'From farm to kitchen, we ensure your ingredients arrive fresh, flavorful, and ready for service.',
            image:
                'https://www.magnafoodservice.co.uk/wp-content/uploads/how-to-choose-the-best-pizza-box-supplier-in-uk.jpg',
        },
    ];

    return (
        <div className="home-page">
            <HeroCarousel slides={slides} />

            <div className="category-section my-4">
                <div className="text-center mb-4">
                    <Title level={2} className="font-bold mb-1">
                        Browse by category
                    </Title>
                    <div className="max-w-20rem m-auto">
                        <Text type="secondary">
                            Check out all the feature categories to discover our wonderful product range.
                        </Text>
                    </div>
                </div>

                <Row justify="center" gutter={[16, 16]}>
                    {categories?.slice(0, 12).map((category, idx) => (
                        <Col xs={12} sm={8} md={6} lg={4} key={category}>
                            <CategoryCard
                                category={{ name: category, image: `./assets/category/${idx + 1}.jpg` }}
                            />
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default Home;

const CategoryCard = ({ category }) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        store.dispatch(setCategory([category.name]));
        navigate(getRoutes().public_catalogue.route());
    }

    return (
        <div
            className="category-card"
            onClick={handleNavigate}
        >
            <Card hoverable>
                <div className="category-image">
                    <Image
                        draggable={false}
                        alt={category.name}
                        src={category.image || PLACEHOLDER_IMAGE}
                        fallback={PLACEHOLDER_IMAGE}
                        preview={false}
                    />
                </div>
                <Title level={5} className="text-center" ellipsis={{ tooltip: true }}>
                    {category.name}
                </Title>
            </Card>
        </div>
    );
};
